export default __webpack_public_path__ + "static/media/logo-iso9001.af049360.svg";